<template>
	<div class="verfahren">
		<v-container :class="{box1: verfahrenDetails.box1 == 1, box2: verfahrenDetails.box2 == 1}">
			<v-row>
				<v-col cols="8">
					<h1>{{verfahrenDetails.titel}} <span v-if="verfahrenDetails.acronym != ''">({{verfahrenDetails.acronym}})</span></h1>
                    <h2><span v-if="verfahrenDetails.autoren != ''">{{verfahrenDetails.autoren}}</span> <span v-if="verfahrenDetails.jahr != ''">({{verfahrenDetails.jahr}})</span></h2>
				</v-col>
				<v-col align-self="center">
					<verfahrenzettel :verfahrenid="verfahrenid"></verfahrenzettel>
				</v-col>
				<v-col align-self="center">
					<lesezeichen :verfahrenid="verfahrenid"></lesezeichen>
				</v-col>
				<v-col align-self="center">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<span v-bind="attrs" v-on="on">
								<v-btn icon color="red" :href="meldungLink">
									<v-icon color="red"	dark>mdi-chat-alert</v-icon>
								</v-btn>
							</span>
						</template>
						<span>Meldung zum Verfahren einreichen (z.B. Aktualisierung der Verfahren, ung&uuml;ltige Links etc.)</span>
					</v-tooltip>
				</v-col>
			</v-row>
			<v-divider></v-divider>
			<v-row>
				<v-col cols="1" align-self="align-center">
					<span style="font-size:14px;">Enthaltene Facetten</span>
				</v-col>				
				<v-col cols="9">
                    <v-chip dense class="ma-2" color="#055d0533" v-show="verfahrenDetails.av1 == 1">Menge</v-chip>
                    <v-chip dense class="ma-2" color="#055d0533" v-show="verfahrenDetails.av2 == 1">Unterbrechungen</v-chip>
                    <v-chip dense class="ma-2" color="#055d0533" v-show="verfahrenDetails.av3 == 1">Gleichzeitigkeit</v-chip>
                    <v-chip dense class="ma-2" color="#055d0533" v-show="verfahrenDetails.av4 == 1">Interdependenz</v-chip>
                    <v-chip dense class="ma-2" color="#055d0533" v-show="verfahrenDetails.av5 == 1">Arbeitsspitzen</v-chip>
                    <v-chip dense class="ma-2" color="#055d0533" v-show="verfahrenDetails.av6 == 1">Erweiterte Erreichbarkeit</v-chip>
                    <v-chip dense class="ma-2" color="#055d0533" v-show="verfahrenDetails.av7 == 1">Unklarheit</v-chip>
				</v-col>
				<!-- 
				<v-col>									
					<modell 
						kontext="verfahrendetail" 
						v-bind:verfahrenid="verfahrenid"
					></modell>
				</v-col>				 
				-->
				<v-col>
					<blume 
						kontext = "verfahrendetail" 
						v-bind:verfahrenid="verfahrenid"
					></blume>
				</v-col>
			</v-row>      
			<v-divider></v-divider>      
			<v-row>
				<v-col>
                    <div v-show="verfahrenDetails.beschreibung != ''">
                        <h3>Beschreibung</h3>
                        <p v-html="verfahrenDetails.beschreibung"></p>
                    </div>
                    <!-- <div v-show="verfahrenDetails.modellAspekt.length >= 1"> -->
                    <div v-show="verfahrenDetails.format != ''">
                        <h3>Format</h3>
                        <p>{{verfahrenDetails.format}}</p>
                    </div>
                    <div v-show="verfahrenDetails.zielgruppe != ''">
                        <h3>Zielgruppe</h3>
                        <p>{{verfahrenDetails.zielgruppe}}</p>
                    </div>
                    <div v-show="verfahrenDetails.zugang != ''">
                        <h3>Zugang</h3>
                        <p>{{verfahrenDetails.zugang}}</p>
                    </div>
                    <div v-show="verfahrenDetails.kosten != ''">
                        <h3>Kosten</h3>
                        <p>{{verfahrenDetails.kosten}}</p>
                    </div>
                    <div v-show="verfahrenDetails.itemanzahl != ''">
                        <h3>Itemanzahl</h3>
                        <p>{{verfahrenDetails.itemanzahl}}</p>
                    </div>
                    <div v-show="verfahrenDetails.zeitaufwand != ''">
                        <h3>Zeitaufwand</h3>
                        <p>{{verfahrenDetails.zeitaufwand}}</p>
                    </div>												
                    <div v-show="verfahrenDetails.quelle != ''">
                        <h3>Quelle</h3>
                        <p>{{verfahrenDetails.quelle}}</p>
                    </div>
                    <div v-show="verfahrenDetails.url != ''">
                        <h3>Weitere Informationen</h3>
                        <p><a :href="verfahrenDetails.url" target="_blank">Weitere Informationen zum Verfahren (externer Link)</a></p>
                    </div>
				</v-col>
			</v-row>
			<v-divider></v-divider>
			<v-row>
				<v-col>
					<!--
					<beitraege :verfahrenid="verfahrenid"></beitraege>
					-->
				</v-col>
			</v-row>
		</v-container>
		<v-btn style="margin-top:1em;margin-bottom:1em;">
			<router-link to="/box">Zur&uuml;ck zur Auswahl</router-link>
		</v-btn>
	</div>
</template>
<script>
	import axios from 'axios';
	import blume from '../components/blume.vue';
	// import modell from '../components/modell.vue';
	import lesezeichen from '../components/lesezeichen.vue';
	import verfahrenzettel from '../components/verfahrenzettel.vue';
	// import beitraege from '../components/beitraege.vue';
	export default {
		name: 'verfahren',
		components: {
			blume,
			// modell,
			// beitraege,
			lesezeichen,
			verfahrenzettel
		},
		props: {
			verfahrenid: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				verfahrenDialog: false,
				verfahrenDetails: {},
				verfahrenBewertung: [],
				meldungLink: "mailto:roman.soucek@fau.de?subject=Meldung zu einem Verfahren der Arbeitsverdichtung&body=Sehr geehrtes AVENUE-Team,%0D%0A%0D%0Aich möchte eine Meldung zum Verfahren mit der Kennung '" + this.verfahrenid + "' machen.%0D%0A%0D%0A%0D%0A%0D%0A"
			}
		},
		methods: {
			async verfahrenDetailsHolen(verfahrenid) {
				// console.log('Verfahrendetails holen');
				axios.get('https://www.arbeitsverdichtung.de/api/verfahren/'+verfahrenid)
				.then(response => {
					this.verfahrenDetails = response.data;
					this.verfahrenBewertung.push(this.verfahrenDetails.bewertung1);
					this.verfahrenBewertung.push(this.verfahrenDetails.bewertung2);
					this.verfahrenBewertung.push(this.verfahrenDetails.bewertung3);
					this.verfahrenBewertung.push(this.verfahrenDetails.bewertung4);
					this.verfahrenBewertung.push(this.verfahrenDetails.bewertung5);
					// console.log("this.verfahrenBewertung");
					// console.log(this.verfahrenBewertung);
				})
				.catch(error => {
					this.errorMessage = error.message;
					console.error("There was an error!", error);
				});
			}
		},
		beforeMount() {
			// console.log(this.verfahrenid);
			this.verfahrenDetailsHolen(this.verfahrenid);
		}
	}
</script>
<style scoped>
	.v-card__title {
		line-break: 1rem;
		margin-bottom: 1rem;
	}
	.v-card__subtitle {
		font-size: 1em;
		margin-bottom: 1rem;
	}
	.v-card__text {
		font-size: 1em;
	}
	.v-card__title {
		line-break: 1rem;
		margin-bottom: 1rem;
	}
	.v-card__actions button {
		margin-right: 0.5em;
	}
	.v-chip:before {
		background-color: rgba(5, 93, 5, 0.2);
	}
	.box1 {
		border-left-style: solid;
		border-left-width: 2em;
		border-left-color: #a3660533;
	}
	.box2 {
		border-left-style: solid;
		border-left-width: 2em;
		border-left-color: #0c366b33;
	}
</style>
